import axios from 'axios';
import { ding_urlFun } from '@/utils/encryption';

// 创建axios实例
const service = axios.create({
  // baseURL: process.env.BASE_API, // api的base_url
  // baseURL: 'http://60.191.57.100:6010',
  timeout: 50000, // 请求超时时间
});

// request拦截器
service.interceptors.request.use(
  (config) => {
    config.headers = { ...ding_urlFun() };
    return config;
  },
  (error) => {
    Promise.reject(error);
  },
);

// respone拦截器
service.interceptors.response.use(
  (response) => {
    if (response.status === 200 || response.status === 304) {
      return response.data;
    } else {
      console.log('网络不太给力哦，检查一下您的网络再试吧！');
    }
  },
  (error) => {
    console.log('err' + error); // for debug
    console.log('网络不太给力哦，检查一下您的网络再试吧！');
    return Promise.reject(error);
  },
);

export default service;
